import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"
import { prefersReducedMotion } from "../utils/motion"

gsap.registerPlugin(ScrollTrigger)

export default function initHero() {
	
	const hero = document.querySelector('.hero')

	if (hero) {

		const background = hero.querySelector('.hero__background')

		if (background) {
			background.heroTween?.kill()

			if (prefersReducedMotion()) {
				gsap.set(background, { clearProps: 'transform' })
				return
			}
		
			background.heroTween = gsap.to(background, {
				yPercent: 25,
				ease: 'none',
				scrollTrigger: {
					trigger: hero,
					start: 'top top',
					end: 'bottom top',
					scrub: true,
				}
			})
		}
	}
}
